import styled from 'styled-components';

export const SpinnerWrapper = styled.div`
    display: flex;
    height: 100%;

    padding: 10rem;
    justify-content: center;
    align-items: center;
`;